var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-old-to-new',{staticClass:"pt-old-to-new__withData",attrs:{"exportLoading":_vm.exportLoading},on:{"exportOldToNew":_vm.exportOldToNew,"bringNewStatistice":_vm.bringNewStatistice}})}
var staticRenderFns = []

export { render, staticRenderFns }